import { SelectIF } from '@/types/common';

export type SeasonT = 'Winter' | 'Spring' | 'Summer' | 'Autumn';

export const SEASONS: SeasonT[] = ['Winter', 'Spring', 'Summer', 'Autumn'];

export const SEASONS_PROPERTIES: SelectIF<SeasonT>[] = [
    {
        value: 'Winter',
        label: 'Зима',
    },
    {
        value: 'Spring',
        label: 'Весна',
    },
    {
        value: 'Summer',
        label: 'Лето',
    },
    {
        value: 'Autumn',
        label: 'Осень',
    },
];

export const isSeason = (value: string): value is SeasonT =>
    SEASONS_PROPERTIES.some((season) => season.value === value);
